<div class="a-w1-column pt-2">
    <form [formGroup]="group">
        <div class="a-w1-row">
            <p-floatlabel variant="on" class="a-w6">
                <p-multiselect id="anios" [options]="anios" formControlName="anios" appendTo="body" styleClass="w-full"
                    size="small" (onChange)="cargarAnios()"></p-multiselect>
                <label for="anios">Años</label>
                <span *ngIf="group.get('anios').invalid && group.get('anios').touched" class="text-xs p-error ">
                    Es necesario seleccionar un rango de dos años.
                </span>
            </p-floatlabel>
            <p-button icon="pi pi-search" label="Buscar" (onClick)="search()" size="small" styleClass="b-w1"></p-button>
        </div>
    </form>
    <app-datatable [dataTable]="datatable" [metadataTable]="metadatatable" [filterGlobal]="true"></app-datatable>
</div>